import { Component, Input } from "@angular/core";

@Component({
  selector: "app-collapsible-list",
  templateUrl: "./collapsible-list.component.html",
  styleUrls: ["./collapsible-list.component.scss"],
  standalone: false,
})
export class CollapsibleListComponent {
  @Input() list: any;
  collapsed = true;

  toggleCollapsed() {
    this.collapsed = !this.collapsed;
  }
}
